import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useGetMeQuery, useGetUserHashQuery } from 'redux-store/api/auth';
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
import { authSelector } from 'redux-store/selector';

declare global {
  interface Window {
    Featurebase: any;
  }
}

const APP_ID = process.env.REACT_APP_FEATUREBASE_APP_ID;
const SDK_SRC = 'https://do.featurebase.app/js/sdk.js';

export const FeaturebaseWidget = () => {
  const { isAuth } = useAppSelector(authSelector);
  const [searchParams] = useSearchParams();

  const { data: meData } = useGetMeQuery(undefined, {
    skip: !isAuth || searchParams.has('entryToken'),
  });
  const { data: userHashData } = useGetUserHashQuery(undefined, {
    skip: !meData,
  });

  const loadFeaturebase = () => {
    return new Promise<void>((resolve) => {
      const oldScript = document.querySelector<HTMLScriptElement>(`script[src="${SDK_SRC}"]`);
      if (oldScript) {
        oldScript.remove();
      }

      const script = document.createElement('script');
      script.src = SDK_SRC;
      script.async = true;
      script.onload = () => resolve();
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    if (!APP_ID) {
      console.error('Featurebase: APP_ID not existing в .env');
      return;
    }

    const init = async () => {
      if (window.Featurebase) {
        try {
          window.Featurebase('shutdown');
        } catch (e) {
          console.warn('Featurebase shutdown error:', e);
        }
      }

      await loadFeaturebase();

      setTimeout(() => {
        if (meData && userHashData) {
          window.Featurebase('boot', {
            appId: APP_ID,
            email: meData.email,
            name: `${meData.firstName} ${meData.lastName}`,
            userId: String(meData.userId),
            userHash: userHashData.userHash,
            createdAt: new Date().toISOString(),
          });
        } else {
          window.Featurebase('boot', { appId: APP_ID, createdAt: new Date().toISOString() });
        }
      }, 500);
    };

    init();
  }, [meData, userHashData]);

  return null;
};
